import React, { useEffect, useState } from "react"
import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import InfoPopup from "components/InfoPopup"
import {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from "reactstrap"
import { fetchUserDetails } from "../../../redux/actions/user"
import "../../../assets/view-user.css"

const ViewUser = () => {
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewFile, setPreviewFile] = useState(null)

  const [openAccordion, setOpenAccordion] = useState("0")

  const toggleAccordion = id => {
    setOpenAccordion(openAccordion === id ? "" : id)
  }

  const openPreview = (path, label) => {
    setPreviewFile({
      url: path,
      name: label,
      type: "image/jpeg",
    })
    setPreviewOpen(true)
  }

  const closePreview = () => {
    setPreviewOpen(false)
    setPreviewFile(null)
  }

  const { enc_id, type } = useParams()
  console.log("enc_id", enc_id)
  console.log("type", type)
  let enc_user_id = ""
  let enc_pvs_entry_id = ""
  if (type == "user") {
    enc_user_id = enc_id
    console.log("enc_user_id", enc_user_id)
  } else if (type == "pvs") {
    enc_pvs_entry_id = enc_id
    console.log("enc_pvs_entry_id", enc_pvs_entry_id)
  }
  const history = useNavigate()
  const dispatch = useDispatch()

  const userState = useSelector(state => state.user)

  const [userData, setUserData] = useState()

  const handleDownload = (url, filename) => {
    fetch(url, { mode: "cors" }) // Fetch the file
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = filename // Set desired filename
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
      .catch(err => console.error("Download failed:", err))
  }

  useEffect(() => {
    let payload = {}
    if (enc_user_id) {
      payload = { enc_user_id }
    } else {
      payload = { enc_pvs_entry_id }
    }
    dispatch(fetchUserDetails(payload))
  }, [dispatch, enc_user_id, enc_pvs_entry_id])

  useEffect(() => {
    if (userState && userState.user) {
      setUserData(userState.user)
    }
  }, [userState])

  console.log("userData", userData)

  const [activeTab, setActiveTab] = useState("profile")

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="mb-4"></div>

          <Nav tabs className="pula-profile-tabs mb-4">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "profile" })}
                onClick={() => toggleTab("profile")}
              >
                <i className="mdi mdi-account-circle me-1"></i>
                Profile Details
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "activity" })}
                onClick={() => toggleTab("activity")}
              >
                <i className="mdi mdi-history me-1"></i>
                User Activity
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab} className="pula-tab-content">
            <TabPane
              tabId="profile"
              className={`pula-tab-pane ${
                activeTab === "profile" ? "active" : ""
              }`}
            >
              {/* Basic Details */}
              {userData && userData.user?.user_id && (
                <Card className="pula-profile-card">
                  <CardBody className="pula-card-body">
                    <div className="pula-card-header mb-4">
                      <div className="pula-card-title">
                        <i className="mdi mdi-account"></i>
                        <span>Basic Details</span>
                      </div>
                    </div>
                    <Row className="align-items-center">
                      <Col md={3} className="text-center">
                        {userData && userData.user.user_profile_url ? (
                          <img
                            src={userData.user.user_profile_url}
                            alt="User"
                            className="pula-profile-avatar border-primary"
                          />
                        ) : (
                          <div className="pula-profile-avatar d-flex align-items-center justify-content-center border-primary">
                           <i className="mdi mdi-account"></i>
                          </div>
                        )}
                      </Col>
                      <Col md={9}>
                        <Row>
                          {[
                            {
                              label: "Name",
                              value:
                                `${userData?.user.first_name || ""} ${
                                  userData?.user.last_name || ""
                                }`.trim() || "-",
                            },
                            {
                              label: "Email Id",
                              value: userData?.user.email_id,
                            },
                            {
                              label: "Mobile No",
                              value: userData?.user.mobile_no,
                            },
                            {
                              label: "User Type",
                              value: userData?.user.user_type,
                            },
                            {
                              label: "Registered Source",
                              value: userData?.user.registration_source,
                            },
                            {
                              label: "Created At",
                              value: userData?.user.created_modified_at,
                            },
                          ].map((item, index) => (
                            <Col md={6} key={index}>
                              <div className="pula-info-row">
                                <span className="label">{item.label}</span>
                                <span className="colon">:</span>
                                <span className="value">
                                  {item.value || "-"}
                                </span>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              )}

              {userData?.pvs_cards?.length > 0 ? (
                <Accordion open={openAccordion} toggle={toggleAccordion}>
                  {userData.pvs_cards.map((pvs, index) => (
                    <AccordionItem key={index}>
                      <AccordionHeader targetId={String(index)}>
                        <i className="mdi mdi-store me-2 text-primary"></i>
                        PVS details for <strong>{pvs.brand_name || "—"}</strong>
                      </AccordionHeader>

                      <AccordionBody accordionId={String(index)}>
                        <Row className="gy-4 pula-info-card">
                          {/* LEFT COLUMN */}
                          <Col md={6}>
                            {[
                              { label: "Seller Name", value: pvs.seller_name },
                              { label: "Mobile", value: pvs.seller_contact_no },
                              { label: "Keywords", value: pvs.keywords_label },
                              {
                                label: "Permanent Address",
                                value: pvs.permanent_address,
                              },
                              {
                                label: "Facebook Link",
                                value: pvs.social_fb_link,
                                isLink: true,
                              },
                            ].map((item, i) => (
                              <div className="pula-info-row" key={i}>
                                <span className="label">{item.label}</span>
                                <span className="colon">:</span>
                                {item.isLink && item.value ? (
                                  <a
                                    href={item.value}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="value"
                                  >
                                    {item.value}
                                  </a>
                                ) : (
                                  <span className="value">
                                    {item.value || "-"}
                                  </span>
                                )}
                              </div>
                            ))}
                          </Col>

                          {/* RIGHT COLUMN */}
                          <Col md={6}>
                            {[
                              { label: "Account ID", value: pvs.account_id },
                              { label: "Email", value: pvs.seller_email_id },
                              { label: "Brand Name", value: pvs.brand_name },
                              {
                                label: "Interest",
                                value: pvs.categories_label,
                              },
                              { label: "Address", value: pvs.address },
                              {
                                label: "Status",
                                value: (
                                  <span className="pula-status-badge">
                                    {pvs.status_label}
                                  </span>
                                ),
                              },
                              {
                                label: "Approval Message",
                                value: pvs.approval_status,
                              },
                            ].map((item, i) => (
                              <div className="pula-info-row" key={i}>
                                <span className="label">{item.label}</span>
                                <span className="colon">:</span>
                                <span className="value">
                                  {item.value || "-"}
                                </span>
                              </div>
                            ))}
                          </Col>
                        </Row>

                        {/* ================= PVS CARD DETAILS ================= */}
                        <Row className="pula-card-info align-items-center">
                          <div className="pula-card-header">
                            <div className="pula-card-title">
                              <i
                                className="ion ion-ios-albums text-success me-2"
                                style={{ fontSize: "20px" }}
                              ></i>
                              PVS Card Details
                            </div>
                          </div>
                          <Col md={12} className="mb-4">
                            {[
                              {
                                label: "Brand Name",
                                value: userData?.pvs_cards?.[0]?.brand_name,
                              },
                              {
                                label: "Card Number",
                                value: userData?.pvs_cards?.[0]?.token_code,
                              },
                              {
                                label: "Pay Id",
                                value: userData?.pvs_cards?.[0]?.pay_id,
                              },
                              {
                                label: "Paid Amount",
                                value: (
                                  <span>
                                    {" "}
                                    ₹ {userData?.pvs_cards?.[0]?.amount || "-"}
                                  </span>
                                ),
                              },
                              {
                                label: "Download Card",
                                value: (
                                  <span>
                                    <a
                                      href="#"
                                      onClick={e => {
                                        e.preventDefault()
                                        handleDownload(
                                          userData?.pvs_cards?.[0]
                                            ?.pvs_card_link,
                                          `${userData?.pvs_cards?.[0]?.token_code}.jpg`
                                        )
                                      }}
                                      className="btn-primary"
                                    >
                                      Download
                                    </a>
                                  </span>
                                ),
                              },
                            ].map((item, index) => (
                              <div key={index} className="mb-2 d-flex">
                                <strong style={{ width: "150px" }}>
                                  {item.label}
                                </strong>
                                <span style={{ width: "30px" }}>:</span>
                                <span>{item.value || "-"}</span>
                              </div>
                            ))}
                          </Col>
                          {/* <Col md={12} className="pvsdet-img-col">
                            <img
                              src={
                                userData?.pvs_cards?.[0]?.pvs_card_link ||
                                "/default-card.png"
                              }
                              alt="PVS Card"
                              className="img-thumbnail img-fluid mb-2"
                              style={{ maxHeight: "120px" }}
                            />
                          </Col> */}
                        </Row>

                        {/* ================= PVS DOCUMENTS (LIST / TABLE) ================= */}
                        <Card className="pula-profile-card">
                          <div className="pula-card-header">
                            <div className="pula-card-title">
                              <i className="ion ion-ios-document"></i>
                              <span>PVS Documents</span>
                            </div>
                          </div>

                          <CardBody className="p-0">
                            {userData?.pvs_cards?.[0] &&
                            [
                              userData.pvs_cards[0].aadhar_card_img_path,
                              userData.pvs_cards[0].aadhar_card_img_back_path,
                              userData.pvs_cards[0].permanent_address_img_path,
                              userData.pvs_cards[0].pune_address_img_path,
                              userData.pvs_cards[0].brand_logo_path,
                              userData.pvs_cards[0].seller_photo_path,
                            ].some(Boolean) ? (
                              <table className="pula-doc-table">
                                <thead>
                                  <tr>
                                    <th>Document</th>
                                    <th className="text-center">Preview</th>
                                    <th className="text-center">Download</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {[
                                    {
                                      label: "Aadhar Card Front",
                                      path: userData.pvs_cards[0]
                                        .aadhar_card_img_path,
                                    },
                                    {
                                      label: "Aadhar Card Back",
                                      path: userData.pvs_cards[0]
                                        .aadhar_card_img_back_path,
                                    },
                                    {
                                      label: "Permanent Address",
                                      path: userData.pvs_cards[0]
                                        .permanent_address_img_path,
                                    },
                                    {
                                      label: "Pune Address",
                                      path: userData.pvs_cards[0]
                                        .pune_address_img_path,
                                    },
                                    {
                                      label: "Brand Logo",
                                      path: userData.pvs_cards[0]
                                        .brand_logo_path,
                                    },
                                    {
                                      label: "Seller Photo",
                                      path: userData.pvs_cards[0]
                                        .seller_photo_path,
                                    },
                                  ]
                                    .filter(doc => doc.path)
                                    .map((doc, index) => (
                                      <tr key={index}>
                                        <td>{doc.label}</td>

                                        <td className="text-center">
                                          <button
                                            className="pula-icon-btn"
                                            onClick={() =>
                                              openPreview(doc.path, doc.label)
                                            }
                                          >
                                            <i className="ion ion-md-eye"></i>
                                          </button>
                                        </td>

                                        <td className="text-center">
                                          <button
                                            className="pula-icon-btn"
                                            onClick={() =>
                                              handleDownload(
                                                doc.path,
                                                `${doc.label.replace(
                                                  /\s+/g,
                                                  "_"
                                                )}.jpg`
                                              )
                                            }
                                          >
                                            <i className="ion ion-md-download"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            ) : (
                              <div className="pula-no-data">
                                No Documents Found
                              </div>
                            )}
                          </CardBody>
                        </Card>
                      </AccordionBody>
                    </AccordionItem>
                  ))}
                </Accordion>
              ) : (
                <div className="pula-no-data text-center">
                  No PVS Details Found
                </div>
              )}

              {/* {userData?.pvs_cards?.length > 0 && (
                <>
                  <Card>
                    <CardBody></CardBody>
                  </Card>
                </>
              )} */}
            </TabPane>

            {/* User Activity */}
            <TabPane
              tabId="activity"
              className={`pula-tab-pane ${
                activeTab === "activity" ? "active" : ""
              }`}
            >
              {((userData?.awards?.length || 0) > 0 ||
                (userData?.lucky_draws?.length || 0) > 0 ||
                (userData?.event_meet_bookings?.length || 0) > 0 ||
                (userData?.event_competition_bookings?.length || 0) > 0) && (
                <>
                  <h4 className="card-title mb-4 d-flex align-items-center">
                    <i
                      className="ion ion-ios-time text-success me-2"
                      style={{ fontSize: "20px" }}
                    ></i>
                    User Past Activity
                  </h4>
                  <Card>
                    <CardBody>
                      <div>
                        <ol className="activity-checkout mb-0 px-4 mt-3">
                          {userData?.awards?.length > 0 && (
                            <li className="checkout-item">
                              <div className="avatar-sm checkout-icon p-1">
                                <div className="avatar-title rounded-circle bg-primary">
                                  <i className="mdi mdi-trophy text-white font-size-20"></i>
                                </div>
                              </div>

                              <div className="feed-item-list mb-3">
                                <h5 className="font-size-16 mb-1">Awards</h5>
                                <p className="text-muted text-truncate mb-2">
                                  {userData.awards[0]?.created_modified_at ||
                                    "-"}
                                </p>

                                <Row className="text-muted">
                                  {[
                                    {
                                      label: "Name",
                                      value: userData.awards[0].full_name,
                                    },
                                    {
                                      label: "Email",
                                      value: userData.awards[0].email_id,
                                      isLink: true,
                                    },
                                    {
                                      label: "Contact Mobile",
                                      value: userData.awards[0].contact_no,
                                    },
                                    {
                                      label: "WhatsApp Mobile",
                                      value: userData.awards[0].wa_mobile_no,
                                    },
                                    {
                                      label: "Facebook Profile",
                                      value: userData.awards[0].fb_profile_link,
                                      isLink: true,
                                    },
                                    {
                                      label: "Facebook Page",
                                      value: userData.awards[0].fb_page_link,
                                      isLink: true,
                                    },
                                    {
                                      label: "Instagram",
                                      value: userData.awards[0].insta_link,
                                      isLink: true,
                                    },
                                    {
                                      label: "Category",
                                      value: userData.awards[0].category,
                                    },
                                    {
                                      label: "Sub Category",
                                      value: userData.awards[0].sub_category,
                                    },
                                    {
                                      label: "Why Participate",
                                      value: userData.awards[0].why_participate,
                                    },
                                    {
                                      label: "Achievements",
                                      value: userData.awards[0].achievements,
                                    },
                                    {
                                      label: "Pula Activity",
                                      value: userData.awards[0].pula_activity,
                                    },
                                    {
                                      label: "Post Frequency",
                                      value: userData.awards[0].post_frequency,
                                    },
                                    {
                                      label: "Review Count",
                                      value: userData.awards[0].review_count,
                                    },
                                    {
                                      label: "Review Link 1",
                                      value: userData.awards[0].review_link_1,
                                      isLink: true,
                                    },
                                    {
                                      label: "Review Link 2",
                                      value: userData.awards[0].review_link_2,
                                      isLink: true,
                                    },
                                    {
                                      label: "Review Link 3",
                                      value: userData.awards[0].review_link_3,
                                      isLink: true,
                                    },
                                    {
                                      label: "Review Link 4",
                                      value: userData.awards[0].review_link_4,
                                      isLink: true,
                                    },
                                    {
                                      label: "Review Link 5",
                                      value: userData.awards[0].review_link_5,
                                      isLink: true,
                                    },
                                    {
                                      label: "Attended Events",
                                      value: userData.awards[0].attended_events,
                                    },
                                    {
                                      label: "Attended Event Names",
                                      value:
                                        userData.awards[0].attended_event_names,
                                    },
                                    {
                                      label: "Amount",
                                      value: (
                                        <span>
                                          {" "}
                                          ₹ {userData.awards[0].amount || "-"}
                                        </span>
                                      ),
                                    },
                                    {
                                      label: "Razorpay Order ID",
                                      value:
                                        userData.awards[0].razorpay_order_id,
                                    },
                                    {
                                      label: "Razorpay Payment ID",
                                      value:
                                        userData.awards[0].razorpay_payment_id,
                                    },
                                    {
                                      label: "Payment Status",
                                      value: (
                                        <span
                                          className={`badge ${
                                            userData.awards[0].payment_status ==
                                            "success"
                                              ? "bg-success"
                                              : "bg-danger"
                                          }`}
                                        >
                                          {userData.awards[0].payment_status ||
                                            "-"}
                                        </span>
                                      ),
                                    },
                                  ].map((item, i) => (
                                    <Col md={6} key={i}>
                                      <div className="d-flex mb-1">
                                        <strong style={{ width: "140px" }}>
                                          {item.label}
                                        </strong>
                                        <span style={{ width: "20px" }}>:</span>
                                        {item.isLink && item.value ? (
                                          <a
                                            href={item.value}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {item.value}
                                          </a>
                                        ) : (
                                          <span>{item.value || "-"}</span>
                                        )}
                                      </div>
                                    </Col>
                                  ))}
                                </Row>
                              </div>
                            </li>
                          )}

                          {/* ====== Lucky Draws Section ====== */}
                          {userData?.lucky_draws?.length > 0 && (
                            <li className="checkout-item">
                              <div className="avatar-sm checkout-icon p-1">
                                <div className="avatar-title rounded-circle bg-primary">
                                  <i className="mdi mdi-cash-multiple text-white font-size-20"></i>
                                </div>
                              </div>

                              <div className="feed-item-list mb-3">
                                <h5 className="font-size-16 mb-1">
                                  Lucky Draws
                                </h5>
                                <p className="text-muted text-truncate mb-2">
                                  {userData.lucky_draws[0]
                                    ?.created_modified_at || "-"}
                                </p>

                                <Row className="text-muted">
                                  {[
                                    {
                                      label: "Name",
                                      value:
                                        `${
                                          userData.lucky_draws[0]?.first_name ||
                                          ""
                                        } ${
                                          userData.lucky_draws[0]?.last_name ||
                                          ""
                                        }`.trim() || "-",
                                    },
                                    {
                                      label: "Email",
                                      value: userData.lucky_draws[0]?.email_id,
                                      isLink: true,
                                    },
                                    {
                                      label: "Contact",
                                      value: userData.lucky_draws[0]?.mobile_no,
                                    },
                                    {
                                      label: "Area",
                                      value: userData.lucky_draws[0]?.area,
                                    },
                                    {
                                      label: "Form ID",
                                      value: userData.lucky_draws[0]?.form_id,
                                    },
                                  ].map((item, i) => (
                                    <Col md={6} key={i}>
                                      <div className="d-flex mb-1">
                                        <strong style={{ width: "140px" }}>
                                          {item.label}
                                        </strong>
                                        <span style={{ width: "20px" }}>:</span>
                                        {item.isLink && item.value ? (
                                          <a
                                            href={item.value}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {item.value}
                                          </a>
                                        ) : (
                                          <span>{item.value || "-"}</span>
                                        )}
                                      </div>
                                    </Col>
                                  ))}
                                </Row>
                              </div>
                            </li>
                          )}

                          {/* ====== Meet Section ====== */}
                          {userData?.event_meet_bookings?.length > 0 && (
                            <li className="checkout-item">
                              <div className="avatar-sm checkout-icon p-1">
                                <div className="avatar-title rounded-circle bg-primary">
                                  <i className="mdi mdi-calendar-check text-white font-size-20"></i>
                                </div>
                              </div>

                              <div className="feed-item-list mb-3">
                                <h5 className="font-size-16 mb-1">Meet</h5>

                                {userData.event_meet_bookings.map(
                                  (event, index) => (
                                    <React.Fragment key={index}>
                                      {index > 0 && <hr />}
                                      <Row className="align-items-center mb-2">
                                        <Col md={6}>
                                          {[
                                            {
                                              label: "Event Date",
                                              value:
                                                event.event_details?.event_date,
                                            },
                                            {
                                              label: "Title",
                                              value: event.event_details?.title,
                                            },
                                            {
                                              label: "Address",
                                              value:
                                                event.event_details?.address,
                                            },
                                            {
                                              label: "Card Number",
                                              value:
                                                userData.pvs_cards?.[0]
                                                  ?.token_code,
                                            },
                                          ].map((item, i) => (
                                            <div
                                              className="d-flex mb-1"
                                              key={i}
                                            >
                                              <strong
                                                style={{ width: "140px" }}
                                              >
                                                {item.label}
                                              </strong>
                                              <span style={{ width: "20px" }}>
                                                :
                                              </span>
                                              <span>{item.value || "-"}</span>
                                            </div>
                                          ))}
                                        </Col>
                                        <Col md={6}>
                                          <img
                                            src={
                                              event.event_details
                                                ?.banner_path ||
                                              "/default-card.png"
                                            }
                                            alt="PVS Card"
                                            className="img-thumbnail img-fluid mb-2"
                                            style={{ maxHeight: "120px" }}
                                          />
                                        </Col>
                                      </Row>

                                      {/* Participants Table */}
                                      {event.event_participant?.length > 0 && (
                                        <>
                                          <h7 className="font-size-16 mb-1">
                                            Participants
                                          </h7>
                                          <table className="table mb-3 table-sm table-bordered">
                                            <thead>
                                              <tr>
                                                <th>User ID</th>
                                                <th>Name</th>
                                                <th>Mobile</th>
                                                <th>Ticket Number</th>
                                                <th>Title</th>
                                                <th>DOB</th>
                                                <th>Amount</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {event.event_participant.map(
                                                (p, i) => (
                                                  <tr key={i}>
                                                    <td>{p.user_id}</td>
                                                    <td>{p.name}</td>
                                                    <td>
                                                      {p.participant_mobile}
                                                    </td>
                                                    <td>
                                                      {p.ticket_number || "-"}
                                                    </td>
                                                    <td>{p.title || "-"}</td>
                                                    <td>
                                                      {p.participant_dob || "-"}
                                                    </td>
                                                    <td>
                                                      ₹ {p.participant_total}
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </tbody>
                                          </table>
                                        </>
                                      )}

                                      {/* Payee Info */}
                                      {event.event_payee && (
                                        <>
                                          <h7 className="font-size-16 mb-1">
                                            Payee
                                          </h7>
                                          <Row>
                                            {[
                                              {
                                                label: "Name",
                                                value:
                                                  event.event_payee?.payee_name,
                                              },
                                              {
                                                label: "Mobile",
                                                value:
                                                  event.event_payee
                                                    ?.payee_mobile,
                                              },
                                              {
                                                label: "Email",
                                                value:
                                                  event.event_payee
                                                    ?.payee_email,
                                              },
                                              {
                                                label: "Total Tickets",
                                                value:
                                                  event.event_payee
                                                    ?.total_tickets,
                                              },
                                              {
                                                label: "Total Amount",
                                                value: (
                                                  <span>
                                                    {" "}
                                                    ₹{" "}
                                                    {event.event_payee
                                                      ?.total_amount || "-"}
                                                  </span>
                                                ),
                                              },
                                              {
                                                label: "Paid Amount",
                                                value: (
                                                  <span>
                                                    {" "}
                                                    ₹{" "}
                                                    {event.event_payee
                                                      ?.discounted_amount ||
                                                      "-"}
                                                  </span>
                                                ),
                                              },
                                              {
                                                label: "Discount Percent",
                                                value:
                                                  event.event_payee
                                                    ?.used_discount_percent,
                                              },
                                              {
                                                label: "Status",
                                                value: (
                                                  <span
                                                    className={`badge ${
                                                      event.event_payee
                                                        ?.status == "Success"
                                                        ? "bg-success"
                                                        : "bg-danger"
                                                    }`}
                                                  >
                                                    {event.event_payee
                                                      ?.status || "-"}
                                                  </span>
                                                ),
                                              },
                                              {
                                                label: "Payment ID",
                                                value:
                                                  event.event_payee
                                                    ?.razorpay_payment_id,
                                              },
                                              {
                                                label: "Order ID",
                                                value:
                                                  event.event_payee
                                                    ?.razorpay_order_id,
                                              },
                                              {
                                                label: "Payment Date",
                                                value:
                                                  event.event_payee
                                                    ?.payment_date,
                                              },
                                            ].map((item, i) => (
                                              <Col md={6} key={i}>
                                                <div className="d-flex mb-1">
                                                  <strong
                                                    style={{ width: "140px" }}
                                                  >
                                                    {item.label}
                                                  </strong>
                                                  <span
                                                    style={{ width: "20px" }}
                                                  >
                                                    :
                                                  </span>
                                                  <span>
                                                    {item.value || "-"}
                                                  </span>
                                                </div>
                                              </Col>
                                            ))}
                                          </Row>
                                        </>
                                      )}
                                    </React.Fragment>
                                  )
                                )}
                              </div>
                            </li>
                          )}

                          {/* ====== Competition Section ====== */}
                          {userData?.event_competition_bookings?.length > 0 && (
                            <li className="checkout-item">
                              <div className="avatar-sm checkout-icon p-1">
                                <div className="avatar-title rounded-circle bg-primary">
                                  <i className="mdi mdi-medal text-white font-size-20"></i>
                                </div>
                              </div>

                              <div className="feed-item-list mb-3">
                                <h5 className="font-size-16 mb-1">
                                  Competition
                                </h5>

                                {userData.event_competition_bookings.map(
                                  (event, index) => (
                                    <React.Fragment key={index}>
                                      {index > 0 && <hr />}
                                      <Row className="align-items-center mb-2">
                                        <Col md={6}>
                                          {[
                                            {
                                              label: "Event Date",
                                              value:
                                                event.event_details?.event_date,
                                            },
                                            {
                                              label: "Title",
                                              value: event.event_details?.title,
                                            },
                                            {
                                              label: "Address",
                                              value:
                                                event.event_details?.address,
                                            },
                                            {
                                              label: "Card Number",
                                              value:
                                                userData.pvs_cards?.[0]
                                                  ?.token_code,
                                            },
                                          ].map((item, i) => (
                                            <div
                                              className="d-flex mb-1"
                                              key={i}
                                            >
                                              <strong
                                                style={{ width: "140px" }}
                                              >
                                                {item.label}
                                              </strong>
                                              <span style={{ width: "20px" }}>
                                                :
                                              </span>
                                              <span>{item.value || "-"}</span>
                                            </div>
                                          ))}
                                        </Col>
                                        <Col md={6}>
                                          <img
                                            src={
                                              event.event_details
                                                ?.banner_path ||
                                              "/default-card.png"
                                            }
                                            alt="PVS Card"
                                            className="img-thumbnail img-fluid mb-2"
                                            style={{ maxHeight: "120px" }}
                                          />
                                        </Col>
                                      </Row>

                                      {/* Participants Table */}
                                      {event.event_participant?.length > 0 && (
                                        <>
                                          <h7 className="font-size-16 mb-1">
                                            Participants
                                          </h7>
                                          <table className="table mb-3 table-sm table-bordered">
                                            <thead>
                                              <tr>
                                                <th>User ID</th>
                                                <th>Name</th>
                                                <th>Mobile</th>
                                                <th>Ticket Number</th>
                                                <th>Title</th>
                                                <th>Performance</th>
                                                <th>DOB</th>
                                                <th>Gender</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {event.event_participant.map(
                                                (p, i) => (
                                                  <tr key={i}>
                                                    <td>{p.user_id}</td>
                                                    <td>{p.name}</td>
                                                    <td>
                                                      {p.participant_number}
                                                    </td>
                                                    <td>
                                                      {p.ticket_number || "-"}
                                                    </td>
                                                    <td>{p.title || "-"}</td>
                                                    <td>
                                                      {p.performance || "-"}
                                                    </td>
                                                    <td>
                                                      {p.participant_dob || "-"}
                                                    </td>
                                                    <td>
                                                      {p.participant_gender ||
                                                        "-"}
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </tbody>
                                          </table>
                                        </>
                                      )}

                                      {/* Payee Info */}
                                      {event.event_payee && (
                                        <>
                                          <h7 className="font-size-16 mb-1">
                                            Payee
                                          </h7>
                                          <Row>
                                            {[
                                              {
                                                label: "Name",
                                                value:
                                                  event.event_payee?.payee_name,
                                              },
                                              {
                                                label: "Mobile",
                                                value:
                                                  event.event_payee
                                                    ?.payee_mobile,
                                              },
                                              {
                                                label: "Email",
                                                value:
                                                  event.event_payee
                                                    ?.payee_email,
                                              },
                                              {
                                                label: "Total Tickets",
                                                value:
                                                  event.event_payee
                                                    ?.total_tickets,
                                              },
                                              {
                                                label: "Total Amount",
                                                value: (
                                                  <span>
                                                    {" "}
                                                    ₹{" "}
                                                    {event.event_payee
                                                      ?.total_amount || "-"}
                                                  </span>
                                                ),
                                              },
                                              {
                                                label: "Paid Amount",
                                                value: (
                                                  <span>
                                                    {" "}
                                                    ₹{" "}
                                                    {event.event_payee
                                                      ?.discounted_amount ||
                                                      "-"}
                                                  </span>
                                                ),
                                              },
                                              {
                                                label: "Discount Percent",
                                                value:
                                                  event.event_payee
                                                    ?.used_discount_percent,
                                              },
                                              {
                                                label: "Status",
                                                value: (
                                                  <span
                                                    className={`badge ${
                                                      event.event_payee
                                                        ?.status == "Success"
                                                        ? "bg-success"
                                                        : "bg-danger"
                                                    }`}
                                                  >
                                                    {event.event_payee
                                                      ?.status || "-"}
                                                  </span>
                                                ),
                                              },
                                              {
                                                label: "Payment ID",
                                                value:
                                                  event.event_payee
                                                    ?.razorpay_payment_id,
                                              },
                                              {
                                                label: "Order ID",
                                                value:
                                                  event.event_payee
                                                    ?.razorpay_order_id,
                                              },
                                              {
                                                label: "Payment Date",
                                                value:
                                                  event.event_payee
                                                    ?.payment_date,
                                              },
                                            ].map((item, i) => (
                                              <Col md={6} key={i}>
                                                <div className="d-flex mb-1">
                                                  <strong
                                                    style={{ width: "140px" }}
                                                  >
                                                    {item.label}
                                                  </strong>
                                                  <span
                                                    style={{ width: "20px" }}
                                                  >
                                                    :
                                                  </span>
                                                  <span>
                                                    {item.value || "-"}
                                                  </span>
                                                </div>
                                              </Col>
                                            ))}
                                          </Row>
                                        </>
                                      )}
                                    </React.Fragment>
                                  )
                                )}
                              </div>
                            </li>
                          )}
                        </ol>
                      </div>
                    </CardBody>
                  </Card>
                </>
              )}
            </TabPane>
          </TabContent>
        </Container>
      </div>
      <InfoPopup
        isOpen={previewOpen}
        toggle={closePreview}
        title="Document Preview"
        previewFile={previewFile}
        btnClass="btn-primary"
      />
    </React.Fragment>
  )
}

export default ViewUser
